import { gql } from '@apollo/client';
import { GqlSeason, GqlSeasonFragment } from '../fragments/season';

export interface Input {
  country: string;
  programId: number;
  name: string;
  type: string;
  sport: string;
  zipCode: string;
  timezone: string;
  copyFromSeason?: CopyFromSeason;
}

export interface Data {
  createSeason: GqlSeason;
}

export interface CopyFromSeason {
  seasonId: string;
  copyDivisionStructure?: boolean;
  copyTeamStructure?: boolean;
}

export interface SeasonDivisionInput {
  name: string;
  competitionGenderName?: string;
  ageDivisionName?: string;
  competitionLevelName?: string;
}

export const MUTATION = gql`
  mutation CreateSeason(
    $country: String!
    $name: String!
    $type: String!
    $programId: Int!
    $startDate: String
    $endDate: String
    $timezone: String!
    $zipCode: String!
    $copyFromSeason: CopyFromSeasonInput
    $sportId: Int
    $areaOfOperation: Int
    $ageDivisions: [Int]
    $competitionGenders: [Int]
    $competitionLevels: [Int]
    $initialDivisions: [SeasonDivisionInput]
  ) {
    createSeason(
      input: {
        country: $country
        name: $name
        type: $type
        programId: $programId
        startDate: $startDate
        endDate: $endDate
        timezone: $timezone
        zipCode: $zipCode
        copyFromSeason: $copyFromSeason
        sportId: $sportId
        areaOfOperation: $areaOfOperation
        ageDivisions: $ageDivisions
        competitionGenders: $competitionGenders
        competitionLevels: $competitionLevels
        initialDivisions: $initialDivisions
      }
    ) {
      ...SeasonFields
    }
  }
  ${GqlSeasonFragment}
`;
